import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tailored-solution',
  templateUrl: './tailored-solution.component.html',
  styleUrls: ['./tailored-solution.component.scss']
})
export class TailoredSolutionComponent implements OnInit {

  features: Array<{ icon: string, title: string, description: string }> = [
    { icon: "assets/svgs/cod_v1/feature_same_day_delivery.svg", title: "Instant Integrations", description: "Integrate our user-friendly APIs with any ecommerce platform instantly for hassle-free setup." },
    { icon: "assets/svgs/cod_v1/feature_nationalwide_coverage.svg", title: "Secure Platform", description: "Our payment gateway ensures safe and secure payments with 3D Secure Authentication, eliminating any chance of fraud." },
    { icon: "assets/svgs/cod_v1/feature_flexible_pricing.svg", title: "Seamless Checkout", description: "Accepting card payments has never been easier for small and medium-sized merchants, eCommerce sites, and marketplaces with Paid." },
    { icon: "assets/svgs/cod_v1/feature_easy_instalment.svg", title: "Grow Your Revenue", description: "Boost your store's revenue exponentially with prepaid orders and increase acceptance rates." },
  ];
  
  constructor() { }

  ngOnInit(): void {
  }

}
